document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('.lens-type-buttons-options input');
  const sunglasses = document.querySelector('.sunglasses');
  const transitionGlasses = document.querySelector('.transition-glasses');

  inputs.forEach(input => {
    input.addEventListener('change', () => {
      if (document.getElementById('extras-three')?.checked) {
        sunglasses?.classList.add('show');
      } else {
        sunglasses?.classList.remove('show');
      }

      if (document.getElementById('extras-four')?.checked) {
        transitionGlasses?.classList.add('show');
      } else {
        transitionGlasses?.classList.remove('show');
      }
    });
  });
});
